<template>
  <div class="dialog-wrap">
    <el-dialog
      title=""
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      @close="submit"
      width="680px"
    >
      <div class="main-wrap">
        <el-descriptions
          direction="horizontal"
          :column="1"
          border
          :labelStyle="mylabel"
          title="学长详情"
        >
          <template slot="extra">
            <el-switch
              style="display: block"
              v-model="content.status"
              active-text="学长状态"
              :active-value="1"
              :inactive-value="0"
              @change="changeStatus"
            ></el-switch>
          </template>
          <el-descriptions-item label="姓名">{{
            content.realname
          }}</el-descriptions-item>
          <el-descriptions-item label="性别">
            <el-tag size="mini">{{
              renderGender(content.gender)
            }}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="手机号">{{
            content.mobile
          }}</el-descriptions-item>
          <el-descriptions-item label="微信号">{{
            content.wechat
          }}</el-descriptions-item>
          <el-descriptions-item label="课时费">{{
            content.fee_amount
          }}元/小时</el-descriptions-item>
          <el-descriptions-item label="服务提供">
            <p
              v-for="(item, $i) in content.provide_services
                ? content.provide_services.split(',')
                : []"
              :key="$i"
            >
              {{ renderProvideService(item) }}
            </p>
          </el-descriptions-item>
          <el-descriptions-item label="优势补充">{{
            content.additional || "-"
          }}</el-descriptions-item>
          <el-descriptions-item label="申请时间">{{
            $moment(content.create_time).format("YYYY.MM.DD")
          }}</el-descriptions-item>
          <el-descriptions-item label="考研年份">{{
            content.recruit_year
          }}</el-descriptions-item>
          <el-descriptions-item label="录取院校">{{
            content.recruit_college_name
          }}</el-descriptions-item>
          <el-descriptions-item label="录取专业">{{
            content.recruit_major_name
          }}</el-descriptions-item>
           <el-descriptions-item label="录取方向">{{
            content.recruit_direction_name
          }}</el-descriptions-item>
          <el-descriptions-item label="考试科目">{{
            content.test_subject_names
          }}</el-descriptions-item>
          <el-descriptions-item label="初试总分">{{
            content.initial_test_score
          }}</el-descriptions-item>
          <el-descriptions-item label="科目分数">{{
            content.test_subject_scores
          }}</el-descriptions-item>
          <el-descriptions-item label="录取类型">{{
            renderRecruitType(content.recruit_type)
          }}</el-descriptions-item>
          <el-descriptions-item label="录取类型">
            <el-image
              style="width: 100px; height: 100px"
              :src="content.recruit_certify_img"
              :preview-src-list="[content.recruit_certify_img]"
            >
            </el-image>
          </el-descriptions-item>
          <el-descriptions-item label="内容备注">
            {{  content.contract_remark }}
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          @click="submit"
        >确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { seniorUpdateStatus } from "@/api/senior";

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    content: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      dialogVisible: this.visible,
      mylabel: {
        width: "120px",
      },
    };
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
    },
  },
  methods: {
    submit() {
      this.$emit("submit");
    },
    renderProvideService(type) {
      const services = {
        1: "资料-整理备考资料",
        2: "经验-分享上岸经验",
        3: "小讲-录制语音课程",
        4: "辅导-辅导1v1学员",
        5: "研讯-汇总专业数据",
      };
      return services[type] || "";
    },
    renderRecruitType(type) {
      const recruitTypes = {
        1: "第一志愿上岸",
        2: "调剂上岸",
        3: "推免",
      };
      return recruitTypes[type] || "";
    },
    renderGender(type) {
      const genders = {
        1: "学长",
        2: "学姐",
      };
      return genders[type] || "";
    },
    changeStatus(e) {
      seniorUpdateStatus({ id: this.content.id, status: e }).then((res) => { });
    },
  },
};
</script>

<style lang="less" scoped>
.dialog-wrap {
  .main-wrap {
  }
  .form-wrap {
    width: 50%;
  }
  .el-form-item-wrap {
    display: flex;

    /deep/ .el-form-item {
      flex: 1;
      margin-bottom: 10px;
    }
  }
  .footer-wrap {
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }
}
</style>
